import { MAX_LENGTH_ERROR } from '@Teams/TeamDetailsPage/TeamDetailsSummaryCard/EditTeamNameForm/constants'

export const PLACEMENT = 'create-team-modal'
export const CREATE_TEAM_MODAL = PLACEMENT
export const CREATE_TEAM_TITLE = 'Give your workspace a name'
export const CREATE_TEAM_DESCRIPTION =
    'Create a name for your project, program or team'
export const TEAM_NAME_FIELD = 'team-name-field'
export const TEAM_NAME_TITLE = 'Workspace name'
export const TEAM_NAME_ERROR =
    'This team already exists in your Business Account.'
export const TEAM_NAME_ERROR_MSG =
    'Team with the same name already exists in this BusinessAccount.'
export const TEAM_NAME_PLACEHOLDER = 'Enter the workspace name'
export const CREATE_TEAM_FORM_NAME = 'create-team-form'
export const NOTE_TEXT = 'Note: you can always change your workspace name later'
export const CREATE_BUTTON_TEXT = 'Create workspace'
export const LINK_TO_LEARN_ABOUT_TEAMS_PERMISSIONS =
    'https://help.fictiv.com/en/articles/6496968-what-are-team-workspaces'
export const LEARN_MORE_TEXT = ' about Team Workspaces'
const REQUIRED_RULE = { required: true, message: 'Workspace name required' }

export const TEAM_NAME_FORM_RULES = [
    REQUIRED_RULE,
    { max: 20, message: MAX_LENGTH_ERROR },
]

export const IS_NEW_TEAM_SEARCH_PARM = 'isNewTeam'
